/**
 * Maps a keyword `origin_source` literal to the family the Sources tab groups it
 * under (A7Y-4883, D12). Pure and frontend-side so a new `confirm.<feeder>` or
 * `backfill:<cache>` literal appears without a backend change; a literal no rule
 * names lands in OTHER_FAMILY and is shown beside its raw text, disclosed as unmapped.
 */

export const OTHER_FAMILY = 'Other (raw literal)';

export const FAMILY_ORDER = [
  'Store autocomplete · App Store',
  'Store autocomplete · Play',
  'SERP',
  'Apple Ads',
  'Confirm feeders',
  'Backfill',
  OTHER_FAMILY,
] as const;

export type SourceFamily = (typeof FAMILY_ORDER)[number];

export function sourceFamily(source: string): SourceFamily {
  if (source === 'asc_suggest') return 'Store autocomplete · App Store';
  if (source === 'gpc_suggest') return 'Store autocomplete · Play';
  if (source.startsWith('serp.')) return 'SERP';
  if (source.startsWith('apple_ads.')) return 'Apple Ads';
  if (source.startsWith('confirm.')) return 'Confirm feeders';
  if (source.startsWith('backfill:')) return 'Backfill';
  return OTHER_FAMILY;
}
